import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { Product } from 'src/app/modals/product.model';
import { SharedMethods } from 'src/app/components/shared/services/sharedMethods-service';

@Component({
  selector: 'app-product-vertical',
  templateUrl: './product-vertical.component.html',
  styleUrls: ['./product-vertical.component.sass']
})
export class ProductVerticalComponent implements OnInit {

 @Input() products: Product[];

 topProduct: Product[] = [];
 bestProduct: Product[] = [];
 featureProduct: Product[] = [];

 constructor(private productService: ProductService, private sharedMethods: SharedMethods ) { }

  ngOnInit() {


    if(this.productService.cacheProduct.length === 0) {

      // this.spinner.show();
      this.productService.getProducts()
     .subscribe(
       (product: Product[]) => {

         this.productService.cacheProduct = product;
         this.products = product

         this.loadVerticalProd();
        // this.spinner.hide();

       }
     )

    } else {

      this.products = this.productService.cacheProduct;
      this.loadVerticalProd();

    }

  }

  loadVerticalProd() {

    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {

        // tslint:disable-next-line:max-line-length
        this.topProduct = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.topProduct);
        // tslint:disable-next-line:max-line-length
        this.bestProduct = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.bestProduct);
        // tslint:disable-next-line:max-line-length
        this.featureProduct = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.featuresProduct);

      });

     } else {

        // tslint:disable-next-line:max-line-length
        this.topProduct = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.topProduct);
        // tslint:disable-next-line:max-line-length
        this.bestProduct = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.bestProduct);
        // tslint:disable-next-line:max-line-length
        this.featureProduct = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.featuresProduct);

    }

  }

  getIdVideo(product) {
    if ( product.linkvideo !== null && product.linkvideo !== undefined ) {
      const tabDate = product.linkvideo.split('/');
      const tab = tabDate[3].split('?');
      return tab[0];
    } else {

      return '';

    }
  }

}
